import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { useSynapse } from 'app/lib/synaptik';
import { Alert, Button, Container, Formbot, Form, Flex, Input, Text } from '@goodrx/matisse';
import { PageHeading } from 'app/components/PageHeading';
import DocumentTitle from 'app/components/core/document-title';

function ForgotPasswordPage() {
  const [emailAddress, setEmailAddress] = useState<string | null>(null);
  const [sendEmail, sendingEmail] = useSynapse(({ user }) => [
    user.sendForgotPasswordEmail,
    user.state.sendingForgotPasswordEmail,
  ]);

  async function handleSubmit({ isValid, values: { email } }: any = {}) {
    if (!isValid) return;

    try {
      await sendEmail(email);
      setEmailAddress(email);
    } catch (error) {
      setEmailAddress(null);
    }
  }

  return (
    <Container maxWidth={450}>
      <Formbot
        validations={{
          email: { required: true },
        }}
        onSubmit={handleSubmit}>
        <Form>
          <DocumentTitle titleKey="ForgotPassword" />
          <PageHeading
            title="Forgot Password"
            subtitle="Enter the email address you signed up with and we'll email you a link to reset your password."
          />

          {emailAddress && (
            <Alert variant="success" data-qa="success_alert">
              We&apos;ve sent an email to {emailAddress} with instructions on how to reset your password.
            </Alert>
          )}

          <Input name="email" label="Email" floating />

          <Button mt={4} size="lg" type="submit" variant="primary" block loading={sendingEmail}>
            Submit
          </Button>

          <Flex mt={4} alignItems="center" justifyContent="space-between">
            <Link to="/login">
              <Text fontSize={14}>Back To Login</Text>
            </Link>
            <Text fontSize={14} color="greyDarker">
              Don&apos;t have an account? <Link to="/register">Sign Up</Link>
            </Text>
          </Flex>
        </Form>
      </Formbot>
    </Container>
  );
}

export default withRouter(ForgotPasswordPage);
